import React from 'react';
import { motion } from 'framer-motion';
import { Users, MapPin, Calendar, Heart } from 'lucide-react';
import PhotoGallery from './PhotoGallery';

const About = () => {
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  const features = [
    { icon: Users, text: "Vibrant Community" },
    { icon: MapPin, text: "Located in Paris" },
    { icon: Calendar, text: "Regular Events" },
    { icon: Heart, text: "Committed to Service" }
  ];

  return (
    <section id="about" className="py-20 sm:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-10">
        <motion.div
          className="text-center max-w-2xl mx-auto mb-16"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <p className="uppercase tracking-[0.25em] text-gold-600 text-xs sm:text-sm font-semibold mb-4">
            Who We Are
          </p>
          <h2 className="font-display text-4xl sm:text-5xl font-semibold text-brand-900">
            Faith brings us together.
          </h2>
        </motion.div>

        <motion.div
          className="flex flex-col items-center lg:grid lg:grid-cols-2 gap-14 lg:gap-16 mb-20"
          variants={fadeIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-center lg:text-left">
            <motion.p
              className="text-lg sm:text-xl text-stone-600 mb-6 leading-relaxed"
              variants={fadeIn}
            >
              Welcome to Rehoboth Ethiopian Protestant Church in Paris.
              We are a vibrant community of believers committed to worship, fellowship, and service.
            </motion.p>
            <motion.p
              className="text-lg sm:text-xl text-stone-600 leading-relaxed"
              variants={fadeIn}
            >
              Our church is a place where faith, culture, and community intersect,
              providing a spiritual home for Ethiopian believers in Paris.
            </motion.p>
          </div>

          <motion.div
            className="grid grid-cols-2 gap-5 w-full max-w-md mx-auto lg:max-w-none"
            variants={fadeIn}
          >
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="group bg-stone-50 p-6 rounded-2xl border border-stone-200/70 flex flex-col items-center text-center transition-all duration-300 hover:bg-white hover:shadow-card-hover hover:-translate-y-1"
                variants={fadeIn}
              >
                <span className="flex items-center justify-center w-14 h-14 rounded-full bg-brand-800 text-white mb-4 transition-colors duration-300 group-hover:bg-gold-500">
                  <feature.icon size={26} />
                </span>
                <p className="text-brand-900 font-semibold text-sm sm:text-base">{feature.text}</p>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="uppercase tracking-[0.25em] text-gold-600 text-xs sm:text-sm font-semibold mb-4">
            Life at Rehoboth
          </p>
          <h3 className="font-display text-3xl sm:text-4xl font-semibold text-brand-900 mb-12">
            Sharing life. Growing in faith.
          </h3>
          <PhotoGallery />
        </motion.div>
      </div>
    </section>
  );
};

export default About;
